export default "__VITE_ASSET__60mWltnA__";